import { FOUNDATION } from "../../constants"

export const STORE_USER_SESSION = `${FOUNDATION}_STORE_USER_SESSION`

export const STORE_USER_INFO = `${FOUNDATION}_STORE_USER_INFO`

export const SIGN_USER_OUT = `${FOUNDATION}_SIGN_USER_OUT`

export const STORE_USER_POOL = `${FOUNDATION}_STORE_USER_POOL`

export const STORE_MODULES = `${FOUNDATION}_STORE_MODULES`

export const REPLACE_PERMISSIONS = `${FOUNDATION}_REPLACE_PERMISSIONS`

export const INITIALISE_SIGNIN_STATE = `${FOUNDATION}_INITIALISE_SIGNIN_STATE`

export const STORE_SETTINGS = `${FOUNDATION}_STORE_SETTINGS`

export const INIT_PERMISSIONS = `${FOUNDATION}_INIT_PERMISSIONS`

export const STORE_PERMISSIONS = `${FOUNDATION}_STORE_PERMISSIONS`

export const UPDATE_API_CLASS = `${FOUNDATION}_UPDATE_API_CLASS`

export const STORE_MODULE_DATA = `${FOUNDATION}_STORE_MODULE_DATA`

export const STORE_PASSWORD_CRITERIA = `${FOUNDATION}_STORE_PASSWORD_CRITERIA`

export const USER_POOL = "UserPool"

export const APPLICATION_CLIENT_ID = "ApplicationClientId"

export const COGNITO_COOKIE_PREFIX = "CognitoIdentityServiceProvider"

export const TOP_DOMAIN = `.${window.location.host
  .split(".")
  .slice(-2)
  .join(".")}`

export const USER_EMAIL = `${COGNITO_COOKIE_PREFIX}.USER_EMAIL`

export const MODULE_ORDER = ["wiki", "srb", "iam", "helpdesk"]

export const RENDER_APPLICATION = `${FOUNDATION}_RENDER_APPLICATION`

export const STORE_AVAILABLE_MODULES = `${FOUNDATION}_STORE_AVAILABLE_MODULES`

export const STORE_SESSION_TIMER = `${FOUNDATION}_STORE_SESSION_TIMER`

export const STORE_SESSION_TIMER_INFO = `${FOUNDATION}_STORE_SESSION_TIMER_INFO`

export const DELETE_SESSION_TIMER = `${FOUNDATION}_DELETE_SESSION_TIMER`

export const SET_ENTITY = `${FOUNDATION}_SET_ENTITY`

export const SET_ENTITIES = `${FOUNDATION}_SET_ENTITIES`

export const SET_CAN_UPDATE_ENTITY = `${FOUNDATION}_SET_CAN_UPDATE_ENTITY`

export const SET_PROTOCOLS = `${FOUNDATION}_SET_PROTOCOLS`

export const animatedModules = ["srb", "wiki", "fts", "ssil", "iam", "helpdesk"]

export const SET_SSO_ENABLED = `${FOUNDATION}_SET_SSO_ENABLED`

export const SET_USER_DETAILS = `${FOUNDATION}_SET_USER_DETAILS`
